const STORAGE_KEY = "wallboards_dev_token";

export function normalizeBearerToken(value) {
  if (!value || typeof value !== "string") {
    return "";
  }
  return value.replace(/^\s*Bearer\s+/i, "").trim();
}

export function getStoredDevToken() {
  try {
    return normalizeBearerToken(localStorage.getItem(STORAGE_KEY) || "");
  } catch (e) {
    return "";
  }
}

/**
 * Effective soft/dev token: UI-stored value overwrites VUE_APP_DEV_TOKEN.
 * Query ?token= still wins (kiosk / deep-link).
 */
export function getDevToken(queryToken) {
  const fromQuery =
    typeof queryToken === "string" ? normalizeBearerToken(queryToken) : "";
  if (fromQuery) {
    return fromQuery;
  }
  const stored = getStoredDevToken();
  if (stored) {
    return stored;
  }
  return normalizeBearerToken(process.env.VUE_APP_DEV_TOKEN || "");
}

export function setStoredDevToken(token) {
  const normalized = normalizeBearerToken(token);
  if (!normalized) {
    clearStoredDevToken();
    return "";
  }
  localStorage.setItem(STORAGE_KEY, normalized);
  return normalized;
}

export function clearStoredDevToken() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}

export function isDevAuthPath(pathname = window.location.pathname) {
  return pathname === "/auth/dev" || pathname.endsWith("/auth/dev");
}

export { STORAGE_KEY };
